import { createElement as _ } from 'react';
export const AccountBook = /*#__PURE__*/ (() => {
    function AccountBookSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 018.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z" })
        );
    }
    function AccountBook({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AccountBookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AccountBook.SVG = AccountBookSVG;
    return AccountBook;
})();
export const Alert = /*#__PURE__*/ (() => {
    function AlertSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 244c176.18 0 319 142.82 319 319v233a32 32 0 01-32 32H225a32 32 0 01-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 018 8v96a8 8 0 01-8 8h-56a8 8 0 01-8-8V76a8 8 0 018-8zM177.25 191.66a8 8 0 0111.32 0l67.88 67.88a8 8 0 010 11.31l-39.6 39.6a8 8 0 01-11.31 0l-67.88-67.88a8 8 0 010-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 010 11.3l-67.88 67.9a8 8 0 01-11.32 0l-39.6-39.6a8 8 0 010-11.32l67.89-67.88a8 8 0 0111.31 0zM192 892h640a32 32 0 0132 32v24a8 8 0 01-8 8H168a8 8 0 01-8-8v-24a32 32 0 0132-32zm148-317v253h64V575h-64z" })
        );
    }
    function Alert({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AlertSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Alert.SVG = AlertSVG;
    return Alert;
})();
export const AlipayCircle = /*#__PURE__*/ (() => {
    function AlipayCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 00960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z" })
        );
    }
    function AlipayCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AlipayCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AlipayCircle.SVG = AlipayCircleSVG;
    return AlipayCircle;
})();
export const AlipaySquare = /*#__PURE__*/ (() => {
    function AlipaySquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z" })
        );
    }
    function AlipaySquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AlipaySquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AlipaySquare.SVG = AlipaySquareSVG;
    return AlipaySquare;
})();
export const Aliwangwang = /*#__PURE__*/ (() => {
    function AliwangwangSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 00-120.5-81.2A375.65 375.65 0 00519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 00-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0029.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z" })
        );
    }
    function Aliwangwang({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AliwangwangSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Aliwangwang.SVG = AliwangwangSVG;
    return Aliwangwang;
})();
export const AmazonCircle = /*#__PURE__*/ (() => {
    function AmazonCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 00-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0125.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 017.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 01-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z" })
        );
    }
    function AmazonCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AmazonCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AmazonCircle.SVG = AmazonCircleSVG;
    return AmazonCircle;
})();
export const AmazonSquare = /*#__PURE__*/ (() => {
    function AmazonSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 00-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0125.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 017.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 01-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z" })
        );
    }
    function AmazonSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AmazonSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AmazonSquare.SVG = AmazonSquareSVG;
    return AmazonSquare;
})();
export const Android = /*#__PURE__*/ (() => {
    function AndroidSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm208.4 0a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z" })
        );
    }
    function Android({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AndroidSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Android.SVG = AndroidSVG;
    return Android;
})();
export const Api = /*#__PURE__*/ (() => {
    function ApiSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z" })
        );
    }
    function Api({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ApiSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Api.SVG = ApiSVG;
    return Api;
})();
export const Apple = /*#__PURE__*/ (() => {
    function AppleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z" })
        );
    }
    function Apple({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AppleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Apple.SVG = AppleSVG;
    return Apple;
})();
export const Appstore = /*#__PURE__*/ (() => {
    function AppstoreSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z" })
        );
    }
    function Appstore({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AppstoreSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Appstore.SVG = AppstoreSVG;
    return Appstore;
})();
export const Audio = /*#__PURE__*/ (() => {
    function AudioSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z" })
        );
    }
    function Audio({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AudioSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Audio.SVG = AudioSVG;
    return Audio;
})();
export const Backward = /*#__PURE__*/ (() => {
    function BackwardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 1024 : '1em',
                height: originalSize ? 1024 : '1em',
                viewBox: "0 0 1024 1024",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 00-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z" })
        );
    }
    function Backward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BackwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Backward.SVG = BackwardSVG;
    return Backward;
})();
export const Bank = /*#__PURE__*/ (() => {
    function BankSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z" })
        );
    }
    function Bank({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BankSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bank.SVG = BankSVG;
    return Bank;
})();
export const BehanceCircle = /*#__PURE__*/ (() => {
    function BehanceCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0017.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z" })
        );
    }
    function BehanceCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BehanceCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BehanceCircle.SVG = BehanceCircleSVG;
    return BehanceCircle;
})();
export const BehanceSquare = /*#__PURE__*/ (() => {
    function BehanceSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z" })
        );
    }
    function BehanceSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BehanceSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BehanceSquare.SVG = BehanceSquareSVG;
    return BehanceSquare;
})();
export const Bell = /*#__PURE__*/ (() => {
    function BellSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z" })
        );
    }
    function Bell({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BellSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bell.SVG = BellSVG;
    return Bell;
})();
export const Book = /*#__PURE__*/ (() => {
    function BookSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z" })
        );
    }
    function Book({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Book.SVG = BookSVG;
    return Book;
})();
export const BoxPlot = /*#__PURE__*/ (() => {
    function BoxPlotSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z" })
        );
    }
    function BoxPlot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BoxPlotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BoxPlot.SVG = BoxPlotSVG;
    return BoxPlot;
})();
export const Bug = /*#__PURE__*/ (() => {
        function BugSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 832 : '1em',
                    height: originalSize ? 832 : '1em',
                    viewBox: "64 64 896 896",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 00-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 00-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z" }),
_('path', { d: "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 01-63 63H232a63 63 0 01-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0022.7 49c24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5a281.38 281.38 0 00123.2-149.5A120.4 120.4 0 01836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" })
            );
        }
        function Bug({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BugSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bug.SVG = BugSVG;
        return Bug;
    })();
export const Build = /*#__PURE__*/ (() => {
    function BuildSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z" })
        );
    }
    function Build({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BuildSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Build.SVG = BuildSVG;
    return Build;
})();
export const Bulb = /*#__PURE__*/ (() => {
    function BulbSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z" })
        );
    }
    function Bulb({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BulbSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bulb.SVG = BulbSVG;
    return Bulb;
})();
export const Calculator = /*#__PURE__*/ (() => {
    function CalculatorSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 01-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z" })
        );
    }
    function Calculator({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CalculatorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Calculator.SVG = CalculatorSVG;
    return Calculator;
})();
export const Calendar = /*#__PURE__*/ (() => {
    function CalendarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z" })
        );
    }
    function Calendar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CalendarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Calendar.SVG = CalendarSVG;
    return Calendar;
})();
export const Camera = /*#__PURE__*/ (() => {
    function CameraSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M864 260H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 10192 0 96 96 0 10-192 0z" })
        );
    }
    function Camera({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CameraSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Camera.SVG = CameraSVG;
    return Camera;
})();
export const Car = /*#__PURE__*/ (() => {
    function CarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M959 413.4L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z" })
        );
    }
    function Car({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Car.SVG = CarSVG;
    return Car;
})();
export const CaretDown = /*#__PURE__*/ (() => {
    function CaretDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 1024 : '1em',
                height: originalSize ? 1024 : '1em',
                viewBox: "0 0 1024 1024",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" })
        );
    }
    function CaretDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CaretDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CaretDown.SVG = CaretDownSVG;
    return CaretDown;
})();
export const CaretLeft = /*#__PURE__*/ (() => {
    function CaretLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 1024 : '1em',
                height: originalSize ? 1024 : '1em',
                viewBox: "0 0 1024 1024",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" })
        );
    }
    function CaretLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CaretLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CaretLeft.SVG = CaretLeftSVG;
    return CaretLeft;
})();
export const CaretRight = /*#__PURE__*/ (() => {
    function CaretRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 1024 : '1em',
                height: originalSize ? 1024 : '1em',
                viewBox: "0 0 1024 1024",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z" })
        );
    }
    function CaretRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CaretRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CaretRight.SVG = CaretRightSVG;
    return CaretRight;
})();
export const CaretUp = /*#__PURE__*/ (() => {
    function CaretUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 1024 : '1em',
                height: originalSize ? 1024 : '1em',
                viewBox: "0 0 1024 1024",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" })
        );
    }
    function CaretUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CaretUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CaretUp.SVG = CaretUpSVG;
    return CaretUp;
})();
export const CarryOut = /*#__PURE__*/ (() => {
    function CarryOutSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z" })
        );
    }
    function CarryOut({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CarryOutSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CarryOut.SVG = CarryOutSVG;
    return CarryOut;
})();
export const CheckCircle = /*#__PURE__*/ (() => {
    function CheckCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" })
        );
    }
    function CheckCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CheckCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CheckCircle.SVG = CheckCircleSVG;
    return CheckCircle;
})();
export const CheckSquare = /*#__PURE__*/ (() => {
    function CheckSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 01-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z" })
        );
    }
    function CheckSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CheckSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CheckSquare.SVG = CheckSquareSVG;
    return CheckSquare;
})();
export const Chrome = /*#__PURE__*/ (() => {
    function ChromeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0096 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z" })
        );
    }
    function Chrome({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChromeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Chrome.SVG = ChromeSVG;
    return Chrome;
})();
export const CiCircle = /*#__PURE__*/ (() => {
    function CiCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z" })
        );
    }
    function CiCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CiCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CiCircle.SVG = CiCircleSVG;
    return CiCircle;
})();
export const ClockCircle = /*#__PURE__*/ (() => {
    function ClockCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 01-11.2 1.7L483.3 569.8a7.92 7.92 0 01-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z" })
        );
    }
    function ClockCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ClockCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ClockCircle.SVG = ClockCircleSVG;
    return ClockCircle;
})();
export const CloseCircle = /*#__PURE__*/ (() => {
    function CloseCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" })
        );
    }
    function CloseCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CloseCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CloseCircle.SVG = CloseCircleSVG;
    return CloseCircle;
})();
export const CloseSquare = /*#__PURE__*/ (() => {
    function CloseSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM676.1 657.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1A7.95 7.95 0 01354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9z" })
        );
    }
    function CloseSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CloseSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CloseSquare.SVG = CloseSquareSVG;
    return CloseSquare;
})();
export const Cloud = /*#__PURE__*/ (() => {
    function CloudSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z" })
        );
    }
    function Cloud({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CloudSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cloud.SVG = CloudSVG;
    return Cloud;
})();
export const CodeSandboxCircle = /*#__PURE__*/ (() => {
    function CodeSandboxCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z" })
        );
    }
    function CodeSandboxCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CodeSandboxCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CodeSandboxCircle.SVG = CodeSandboxCircleSVG;
    return CodeSandboxCircle;
})();
export const CodeSandboxSquare = /*#__PURE__*/ (() => {
    function CodeSandboxSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z" })
        );
    }
    function CodeSandboxSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CodeSandboxSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CodeSandboxSquare.SVG = CodeSandboxSquareSVG;
    return CodeSandboxSquare;
})();
export const Code = /*#__PURE__*/ (() => {
    function CodeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 01-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z" })
        );
    }
    function Code({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Code.SVG = CodeSVG;
    return Code;
})();
export const CodepenCircle = /*#__PURE__*/ (() => {
    function CodepenCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z" })
        );
    }
    function CodepenCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CodepenCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CodepenCircle.SVG = CodepenCircleSVG;
    return CodepenCircle;
})();
export const CodepenSquare = /*#__PURE__*/ (() => {
    function CodepenSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z" })
        );
    }
    function CodepenSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CodepenSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CodepenSquare.SVG = CodepenSquareSVG;
    return CodepenSquare;
})();
export const Compass = /*#__PURE__*/ (() => {
    function CompassSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z" })
        );
    }
    function Compass({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CompassSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Compass.SVG = CompassSVG;
    return Compass;
})();
export const Contacts = /*#__PURE__*/ (() => {
    function ContactsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 01-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 01-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z" })
        );
    }
    function Contacts({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ContactsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Contacts.SVG = ContactsSVG;
    return Contacts;
})();
export const Container = /*#__PURE__*/ (() => {
    function ContainerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 01-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z" })
        );
    }
    function Container({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ContainerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Container.SVG = ContainerSVG;
    return Container;
})();
export const Control = /*#__PURE__*/ (() => {
    function ControlSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1072 0 36 36 0 10-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 00-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z" })
        );
    }
    function Control({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ControlSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Control.SVG = ControlSVG;
    return Control;
})();
export const Copy = /*#__PURE__*/ (() => {
    function CopySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z" })
        );
    }
    function Copy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CopySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Copy.SVG = CopySVG;
    return Copy;
})();
export const CopyrightCircle = /*#__PURE__*/ (() => {
    function CopyrightCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z" })
        );
    }
    function CopyrightCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CopyrightCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CopyrightCircle.SVG = CopyrightCircleSVG;
    return CopyrightCircle;
})();
export const CreditCard = /*#__PURE__*/ (() => {
    function CreditCardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z" })
        );
    }
    function CreditCard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CreditCardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CreditCard.SVG = CreditCardSVG;
    return CreditCard;
})();
export const Crown = /*#__PURE__*/ (() => {
    function CrownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z" })
        );
    }
    function Crown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CrownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Crown.SVG = CrownSVG;
    return Crown;
})();
export const CustomerService = /*#__PURE__*/ (() => {
    function CustomerServiceSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z" })
        );
    }
    function CustomerService({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CustomerServiceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CustomerService.SVG = CustomerServiceSVG;
    return CustomerService;
})();
export const Dashboard = /*#__PURE__*/ (() => {
    function DashboardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 01-11.3 0L261.7 352a8.03 8.03 0 010-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 01-79.2 0 55.95 55.95 0 010-79.2 55.87 55.87 0 0154.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 010-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 01-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z" })
        );
    }
    function Dashboard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DashboardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Dashboard.SVG = DashboardSVG;
    return Dashboard;
})();
export const Database = /*#__PURE__*/ (() => {
    function DatabaseSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z" })
        );
    }
    function Database({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DatabaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Database.SVG = DatabaseSVG;
    return Database;
})();
export const Delete = /*#__PURE__*/ (() => {
    function DeleteSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z" })
        );
    }
    function Delete({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DeleteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Delete.SVG = DeleteSVG;
    return Delete;
})();
export const Diff = /*#__PURE__*/ (() => {
    function DiffSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z" })
        );
    }
    function Diff({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DiffSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Diff.SVG = DiffSVG;
    return Diff;
})();
export const DingtalkCircle = /*#__PURE__*/ (() => {
    function DingtalkCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z" })
        );
    }
    function DingtalkCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DingtalkCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    DingtalkCircle.SVG = DingtalkCircleSVG;
    return DingtalkCircle;
})();
export const DingtalkSquare = /*#__PURE__*/ (() => {
    function DingtalkSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z" })
        );
    }
    function DingtalkSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DingtalkSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    DingtalkSquare.SVG = DingtalkSquareSVG;
    return DingtalkSquare;
})();
export const Dislike = /*#__PURE__*/ (() => {
    function DislikeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z" })
        );
    }
    function Dislike({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DislikeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Dislike.SVG = DislikeSVG;
    return Dislike;
})();
export const DollarCircle = /*#__PURE__*/ (() => {
    function DollarCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z" })
        );
    }
    function DollarCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DollarCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    DollarCircle.SVG = DollarCircleSVG;
    return DollarCircle;
})();
export const DownCircle = /*#__PURE__*/ (() => {
    function DownCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z" })
        );
    }
    function DownCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DownCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    DownCircle.SVG = DownCircleSVG;
    return DownCircle;
})();
export const DownSquare = /*#__PURE__*/ (() => {
    function DownSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z" })
        );
    }
    function DownSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DownSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    DownSquare.SVG = DownSquareSVG;
    return DownSquare;
})();
export const DribbbleCircle = /*#__PURE__*/ (() => {
    function DribbbleCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M675.1 328.3a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z" })
        );
    }
    function DribbbleCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DribbbleCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    DribbbleCircle.SVG = DribbbleCircleSVG;
    return DribbbleCircle;
})();
export const DribbbleSquare = /*#__PURE__*/ (() => {
    function DribbbleSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z" })
        );
    }
    function DribbbleSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DribbbleSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    DribbbleSquare.SVG = DribbbleSquareSVG;
    return DribbbleSquare;
})();
export const DropboxCircle = /*#__PURE__*/ (() => {
    function DropboxCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z" })
        );
    }
    function DropboxCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DropboxCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    DropboxCircle.SVG = DropboxCircleSVG;
    return DropboxCircle;
})();
export const DropboxSquare = /*#__PURE__*/ (() => {
    function DropboxSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z" })
        );
    }
    function DropboxSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DropboxSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    DropboxSquare.SVG = DropboxSquareSVG;
    return DropboxSquare;
})();
export const Edit = /*#__PURE__*/ (() => {
    function EditSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z" })
        );
    }
    function Edit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EditSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Edit.SVG = EditSVG;
    return Edit;
})();
export const Environment = /*#__PURE__*/ (() => {
    function EnvironmentSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 00400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 00512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z" })
        );
    }
    function Environment({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EnvironmentSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Environment.SVG = EnvironmentSVG;
    return Environment;
})();
export const EuroCircle = /*#__PURE__*/ (() => {
    function EuroCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z" })
        );
    }
    function EuroCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EuroCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    EuroCircle.SVG = EuroCircleSVG;
    return EuroCircle;
})();
export const ExclamationCircle = /*#__PURE__*/ (() => {
    function ExclamationCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" })
        );
    }
    function ExclamationCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ExclamationCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ExclamationCircle.SVG = ExclamationCircleSVG;
    return ExclamationCircle;
})();
export const Experiment = /*#__PURE__*/ (() => {
    function ExperimentSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0094.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 01164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 01-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0036.6-82.5z" })
        );
    }
    function Experiment({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ExperimentSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Experiment.SVG = ExperimentSVG;
    return Experiment;
})();
export const EyeInvisible = /*#__PURE__*/ (() => {
        function EyeInvisibleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 832 : '1em',
                    height: originalSize ? 832 : '1em',
                    viewBox: "64 64 896 896",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M508 624a112 112 0 00112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 00-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 000 11.31L155.25 889a8 8 0 0011.31 0l712.16-712.12a8 8 0 000-11.32zM332 512a176 176 0 01258.88-155.28l-48.62 48.62a112.08 112.08 0 00-140.92 140.92l-48.62 48.62A175.09 175.09 0 01332 512z" }),
_('path', { d: "M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 01445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5z" })
            );
        }
        function EyeInvisible({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EyeInvisibleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EyeInvisible.SVG = EyeInvisibleSVG;
        return EyeInvisible;
    })();
export const Eye = /*#__PURE__*/ (() => {
    function EyeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M396 512a112 112 0 10224 0 112 112 0 10-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z" })
        );
    }
    function Eye({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EyeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eye.SVG = EyeSVG;
    return Eye;
})();
export const Facebook = /*#__PURE__*/ (() => {
    function FacebookSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z" })
        );
    }
    function Facebook({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FacebookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Facebook.SVG = FacebookSVG;
    return Facebook;
})();
export const FastBackward = /*#__PURE__*/ (() => {
    function FastBackwardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 1024 : '1em',
                height: originalSize ? 1024 : '1em',
                viewBox: "0 0 1024 1024",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M517.6 273.5L230.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" })
        );
    }
    function FastBackward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FastBackwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FastBackward.SVG = FastBackwardSVG;
    return FastBackward;
})();
export const FastForward = /*#__PURE__*/ (() => {
    function FastForwardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 1024 : '1em',
                height: originalSize ? 1024 : '1em',
                viewBox: "0 0 1024 1024",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 000-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" })
        );
    }
    function FastForward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FastForwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FastForward.SVG = FastForwardSVG;
    return FastForward;
})();
export const FileAdd = /*#__PURE__*/ (() => {
    function FileAddSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M480 580H372a8 8 0 00-8 8v48a8 8 0 008 8h108v108a8 8 0 008 8h48a8 8 0 008-8V644h108a8 8 0 008-8v-48a8 8 0 00-8-8H544V472a8 8 0 00-8-8h-48a8 8 0 00-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" })
        );
    }
    function FileAdd({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileAddSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileAdd.SVG = FileAddSVG;
    return FileAdd;
})();
export const FileExcel = /*#__PURE__*/ (() => {
    function FileExcelSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 00-10.27-5.79h-38.44a12 12 0 00-6.4 1.85 12 12 0 00-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 00-1.84 6.39 12 12 0 0012 12h34.46a12 12 0 0010.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0010.23 5.72h37.48a12 12 0 006.48-1.9 12 12 0 003.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 001.9-6.5 12 12 0 00-12-12h-35.7a12 12 0 00-10.29 5.84z" })
        );
    }
    function FileExcel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileExcelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileExcel.SVG = FileExcelSVG;
    return FileExcel;
})();
export const FileExclamation = /*#__PURE__*/ (() => {
    function FileExclamationSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 100-80 40 40 0 000 80zm32-152V448a8 8 0 00-8-8h-48a8 8 0 00-8 8v184a8 8 0 008 8h48a8 8 0 008-8z" })
        );
    }
    function FileExclamation({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileExclamationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileExclamation.SVG = FileExclamationSVG;
    return FileExclamation;
})();
export const FileImage = /*#__PURE__*/ (() => {
    function FileImageSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0112.6 0l41.1 52.4 77.8-99.2a8 8 0 0112.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z" })
        );
    }
    function FileImage({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileImageSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileImage.SVG = FileImageSVG;
    return FileImage;
})();
export const FileMarkdown = /*#__PURE__*/ (() => {
    function FileMarkdownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0014.62 9.5h24.06a16 16 0 0014.63-9.51l59.1-133.35V758a16 16 0 0016.01 16H641a16 16 0 0016-16V486a16 16 0 00-16-16h-34.75a16 16 0 00-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 00-14.67-9.61H383a16 16 0 00-16 16v272a16 16 0 0016 16h27.13a16 16 0 0016-16V600.93z" })
        );
    }
    function FileMarkdown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileMarkdownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileMarkdown.SVG = FileMarkdownSVG;
    return FileMarkdown;
})();
export const FilePdf = /*#__PURE__*/ (() => {
    function FilePdfSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 015.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 01-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 01-1.12-.15 2.07 2.07 0 01-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 01-1.36 6.31 6.7 6.7 0 01-2.17 1.28z" })
        );
    }
    function FilePdf({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FilePdfSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FilePdf.SVG = FilePdfSVG;
    return FilePdf;
})();
export const FilePpt = /*#__PURE__*/ (() => {
    function FilePptSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 00-12 12v276a12 12 0 0012 12h32.53a12 12 0 0012-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z" })
        );
    }
    function FilePpt({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FilePptSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FilePpt.SVG = FilePptSVG;
    return FilePpt;
})();
export const FileText = /*#__PURE__*/ (() => {
    function FileTextSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 00-8 8v48a8 8 0 008 8h384a8 8 0 008-8v-48a8 8 0 00-8-8H320zm0 136a8 8 0 00-8 8v48a8 8 0 008 8h184a8 8 0 008-8v-48a8 8 0 00-8-8H320z" })
        );
    }
    function FileText({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileTextSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileText.SVG = FileTextSVG;
    return FileText;
})();
export const FileUnknown = /*#__PURE__*/ (() => {
    function FileUnknownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 100-64 32 32 0 000 64z" })
        );
    }
    function FileUnknown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileUnknownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileUnknown.SVG = FileUnknownSVG;
    return FileUnknown;
})();
export const FileWord = /*#__PURE__*/ (() => {
    function FileWordSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0011.6 8.9h31.77a12 12 0 0011.6-8.88l74.37-276a12 12 0 00.4-3.12 12 12 0 00-12-12h-35.57a12 12 0 00-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 00528.1 472h-32.2a12 12 0 00-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 00-11.68-9.29h-35.39a12 12 0 00-3.11.41 12 12 0 00-8.47 14.7l74.17 276A12 12 0 00415.6 772h31.99a12 12 0 0011.59-8.9l52.81-197z" })
        );
    }
    function FileWord({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileWordSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileWord.SVG = FileWordSVG;
    return FileWord;
})();
export const FileZip = /*#__PURE__*/ (() => {
    function FileZipSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z" })
        );
    }
    function FileZip({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileZipSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileZip.SVG = FileZipSVG;
    return FileZip;
})();
export const File = /*#__PURE__*/ (() => {
    function FileSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" })
        );
    }
    function File({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    File.SVG = FileSVG;
    return File;
})();
export const Filter = /*#__PURE__*/ (() => {
    function FilterSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" })
        );
    }
    function Filter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FilterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Filter.SVG = FilterSVG;
    return Filter;
})();
export const Fire = /*#__PURE__*/ (() => {
    function FireSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9z" })
        );
    }
    function Fire({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FireSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fire.SVG = FireSVG;
    return Fire;
})();
export const Flag = /*#__PURE__*/ (() => {
    function FlagSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z" })
        );
    }
    function Flag({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FlagSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flag.SVG = FlagSVG;
    return Flag;
})();
export const FolderAdd = /*#__PURE__*/ (() => {
    function FolderAddSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z" })
        );
    }
    function FolderAdd({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderAddSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderAdd.SVG = FolderAddSVG;
    return FolderAdd;
})();
export const FolderOpen = /*#__PURE__*/ (() => {
    function FolderOpenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z" })
        );
    }
    function FolderOpen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderOpenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderOpen.SVG = FolderOpenSVG;
    return FolderOpen;
})();
export const Folder = /*#__PURE__*/ (() => {
    function FolderSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z" })
        );
    }
    function Folder({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Folder.SVG = FolderSVG;
    return Folder;
})();
export const FormatPainter = /*#__PURE__*/ (() => {
    function FormatPainterSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 1.1.2 2.2.6 3.1-.4 1.6-.6 3.2-.6 4.9 0 46.4 37.6 84 84 84s84-37.6 84-84c0-1.7-.2-3.3-.6-4.9.4-1 .6-2 .6-3.1V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40z" })
        );
    }
    function FormatPainter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FormatPainterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FormatPainter.SVG = FormatPainterSVG;
    return FormatPainter;
})();
export const Forward = /*#__PURE__*/ (() => {
    function ForwardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 1024 : '1em',
                height: originalSize ? 1024 : '1em',
                viewBox: "0 0 1024 1024",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z" })
        );
    }
    function Forward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ForwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Forward.SVG = ForwardSVG;
    return Forward;
})();
export const Frown = /*#__PURE__*/ (() => {
    function FrownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 01-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 01-8 8.4zm24-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" })
        );
    }
    function Frown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FrownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Frown.SVG = FrownSVG;
    return Frown;
})();
export const Fund = /*#__PURE__*/ (() => {
    function FundSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 01-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 01-11.3 0l-36.8-36.8a8.03 8.03 0 010-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z" })
        );
    }
    function Fund({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FundSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fund.SVG = FundSVG;
    return Fund;
})();
export const FunnelPlot = /*#__PURE__*/ (() => {
    function FunnelPlotSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z" })
        );
    }
    function FunnelPlot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FunnelPlotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FunnelPlot.SVG = FunnelPlotSVG;
    return FunnelPlot;
})();
export const Gift = /*#__PURE__*/ (() => {
    function GiftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z" })
        );
    }
    function Gift({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GiftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gift.SVG = GiftSVG;
    return Gift;
})();
export const Github = /*#__PURE__*/ (() => {
    function GithubSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" })
        );
    }
    function Github({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GithubSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Github.SVG = GithubSVG;
    return Github;
})();
export const Gitlab = /*#__PURE__*/ (() => {
    function GitlabSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z" })
        );
    }
    function Gitlab({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GitlabSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gitlab.SVG = GitlabSVG;
    return Gitlab;
})();
export const Gold = /*#__PURE__*/ (() => {
    function GoldSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z" })
        );
    }
    function Gold({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GoldSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gold.SVG = GoldSVG;
    return Gold;
})();
export const Golden = /*#__PURE__*/ (() => {
    function GoldenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z" })
        );
    }
    function Golden({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GoldenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Golden.SVG = GoldenSVG;
    return Golden;
})();
export const GoogleCircle = /*#__PURE__*/ (() => {
    function GoogleCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z" })
        );
    }
    function GoogleCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GoogleCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    GoogleCircle.SVG = GoogleCircleSVG;
    return GoogleCircle;
})();
export const GooglePlusCircle = /*#__PURE__*/ (() => {
    function GooglePlusCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z" })
        );
    }
    function GooglePlusCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GooglePlusCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    GooglePlusCircle.SVG = GooglePlusCircleSVG;
    return GooglePlusCircle;
})();
export const GooglePlusSquare = /*#__PURE__*/ (() => {
    function GooglePlusSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z" })
        );
    }
    function GooglePlusSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GooglePlusSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    GooglePlusSquare.SVG = GooglePlusSquareSVG;
    return GooglePlusSquare;
})();
export const GoogleSquare = /*#__PURE__*/ (() => {
    function GoogleSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 01272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z" })
        );
    }
    function GoogleSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GoogleSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    GoogleSquare.SVG = GoogleSquareSVG;
    return GoogleSquare;
})();
export const Hdd = /*#__PURE__*/ (() => {
    function HddSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z" })
        );
    }
    function Hdd({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HddSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hdd.SVG = HddSVG;
    return Hdd;
})();
export const Heart = /*#__PURE__*/ (() => {
    function HeartSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z" })
        );
    }
    function Heart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HeartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Heart.SVG = HeartSVG;
    return Heart;
})();
export const Highlight = /*#__PURE__*/ (() => {
    function HighlightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M957.6 507.4L603.2 158.2a7.9 7.9 0 00-11.2 0L353.3 393.4a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z" })
        );
    }
    function Highlight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HighlightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Highlight.SVG = HighlightSVG;
    return Highlight;
})();
export const Home = /*#__PURE__*/ (() => {
    function HomeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M946.5 505L534.6 93.4a31.93 31.93 0 00-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z" })
        );
    }
    function Home({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HomeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home.SVG = HomeSVG;
    return Home;
})();
export const Hourglass = /*#__PURE__*/ (() => {
    function HourglassSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z" })
        );
    }
    function Hourglass({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HourglassSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hourglass.SVG = HourglassSVG;
    return Hourglass;
})();
export const Html5 = /*#__PURE__*/ (() => {
    function Html5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z" })
        );
    }
    function Html5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Html5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Html5.SVG = Html5SVG;
    return Html5;
})();
export const Idcard = /*#__PURE__*/ (() => {
    function IdcardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 01-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 01-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z" })
        );
    }
    function Idcard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IdcardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Idcard.SVG = IdcardSVG;
    return Idcard;
})();
export const IeCircle = /*#__PURE__*/ (() => {
    function IeCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z" })
        );
    }
    function IeCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IeCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    IeCircle.SVG = IeCircleSVG;
    return IeCircle;
})();
export const IeSquare = /*#__PURE__*/ (() => {
    function IeSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z" })
        );
    }
    function IeSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IeSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    IeSquare.SVG = IeSquareSVG;
    return IeSquare;
})();
export const InfoCircle = /*#__PURE__*/ (() => {
    function InfoCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" })
        );
    }
    function InfoCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( InfoCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    InfoCircle.SVG = InfoCircleSVG;
    return InfoCircle;
})();
export const Instagram = /*#__PURE__*/ (() => {
    function InstagramSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 01-47.9 47.9z" })
        );
    }
    function Instagram({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( InstagramSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Instagram.SVG = InstagramSVG;
    return Instagram;
})();
export const Insurance = /*#__PURE__*/ (() => {
    function InsuranceSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 01-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 01-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 01-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 01-8.9-1.4L430 605.7a6 6 0 011.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z" })
        );
    }
    function Insurance({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( InsuranceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Insurance.SVG = InsuranceSVG;
    return Insurance;
})();
export const Interaction = /*#__PURE__*/ (() => {
    function InteractionSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z" })
        );
    }
    function Interaction({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( InteractionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Interaction.SVG = InteractionSVG;
    return Interaction;
})();
export const Layout = /*#__PURE__*/ (() => {
    function LayoutSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z" })
        );
    }
    function Layout({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LayoutSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Layout.SVG = LayoutSVG;
    return Layout;
})();
export const LeftCircle = /*#__PURE__*/ (() => {
    function LeftCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178a8 8 0 0112.7 6.5v46.8z" })
        );
    }
    function LeftCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LeftCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    LeftCircle.SVG = LeftCircleSVG;
    return LeftCircle;
})();
export const LeftSquare = /*#__PURE__*/ (() => {
    function LeftSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z" })
        );
    }
    function LeftSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LeftSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    LeftSquare.SVG = LeftSquareSVG;
    return LeftSquare;
})();
export const Like = /*#__PURE__*/ (() => {
    function LikeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z" })
        );
    }
    function Like({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LikeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Like.SVG = LikeSVG;
    return Like;
})();
export const Linkedin = /*#__PURE__*/ (() => {
    function LinkedinSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1168.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z" })
        );
    }
    function Linkedin({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LinkedinSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Linkedin.SVG = LinkedinSVG;
    return Linkedin;
})();
export const Lock = /*#__PURE__*/ (() => {
    function LockSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1156 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z" })
        );
    }
    function Lock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lock.SVG = LockSVG;
    return Lock;
})();
export const MacCommand = /*#__PURE__*/ (() => {
        function MacCommandSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 832 : '1em',
                    height: originalSize ? 832 : '1em',
                    viewBox: "64 64 896 896",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M624 672a48.01 48.01 0 0096 0c0-26.5-21.5-48-48-48h-48v48zm96-320a48.01 48.01 0 00-96 0v48h48c26.5 0 48-21.5 48-48z" }),
_('path', { d: "M928 64H96c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM672 560c61.9 0 112 50.1 112 112s-50.1 112-112 112-112-50.1-112-112v-48h-96v48c0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112h48v-96h-48c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112v48h96v-48c0-61.9 50.1-112 112-112s112 50.1 112 112-50.1 112-112 112h-48v96h48z" }),
_('path', { d: "M464 464h96v96h-96zM352 304a48.01 48.01 0 000 96h48v-48c0-26.5-21.5-48-48-48zm-48 368a48.01 48.01 0 0096 0v-48h-48c-26.5 0-48 21.5-48 48z" })
            );
        }
        function MacCommand({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MacCommandSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MacCommand.SVG = MacCommandSVG;
        return MacCommand;
    })();
export const Mail = /*#__PURE__*/ (() => {
    function MailSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 01194 256h648.8a7.2 7.2 0 014.4 12.9z" })
        );
    }
    function Mail({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MailSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mail.SVG = MailSVG;
    return Mail;
})();
export const MedicineBox = /*#__PURE__*/ (() => {
    function MedicineBoxSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z" })
        );
    }
    function MedicineBox({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MedicineBoxSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MedicineBox.SVG = MedicineBoxSVG;
    return MedicineBox;
})();
export const MediumCircle = /*#__PURE__*/ (() => {
    function MediumCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 007-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z" })
        );
    }
    function MediumCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MediumCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MediumCircle.SVG = MediumCircleSVG;
    return MediumCircle;
})();
export const MediumSquare = /*#__PURE__*/ (() => {
    function MediumSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 007-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z" })
        );
    }
    function MediumSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MediumSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MediumSquare.SVG = MediumSquareSVG;
    return MediumSquare;
})();
export const Meh = /*#__PURE__*/ (() => {
    function MehSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" })
        );
    }
    function Meh({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MehSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Meh.SVG = MehSVG;
    return Meh;
})();
export const Message = /*#__PURE__*/ (() => {
    function MessageSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M924.3 338.4a447.57 447.57 0 00-96.1-143.3 443.09 443.09 0 00-143-96.3A443.91 443.91 0 00512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 00-141.7 96.5 445 445 0 00-95 142.8A449.89 449.89 0 0065 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 00199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 00827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z" })
        );
    }
    function Message({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MessageSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Message.SVG = MessageSVG;
    return Message;
})();
export const MinusCircle = /*#__PURE__*/ (() => {
    function MinusCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z" })
        );
    }
    function MinusCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MinusCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MinusCircle.SVG = MinusCircleSVG;
    return MinusCircle;
})();
export const MinusSquare = /*#__PURE__*/ (() => {
    function MinusSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z" })
        );
    }
    function MinusSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MinusSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MinusSquare.SVG = MinusSquareSVG;
    return MinusSquare;
})();
export const Mobile = /*#__PURE__*/ (() => {
    function MobileSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" })
        );
    }
    function Mobile({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MobileSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mobile.SVG = MobileSVG;
    return Mobile;
})();
export const MoneyCollect = /*#__PURE__*/ (() => {
    function MoneyCollectSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M911.5 699.7a8 8 0 00-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 017.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z" })
        );
    }
    function MoneyCollect({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MoneyCollectSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MoneyCollect.SVG = MoneyCollectSVG;
    return MoneyCollect;
})();
export const Notification = /*#__PURE__*/ (() => {
    function NotificationSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z" })
        );
    }
    function Notification({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( NotificationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Notification.SVG = NotificationSVG;
    return Notification;
})();
export const PauseCircle = /*#__PURE__*/ (() => {
    function PauseCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z" })
        );
    }
    function PauseCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PauseCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PauseCircle.SVG = PauseCircleSVG;
    return PauseCircle;
})();
export const PayCircle = /*#__PURE__*/ (() => {
    function PayCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 017-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 017.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z" })
        );
    }
    function PayCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PayCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PayCircle.SVG = PayCircleSVG;
    return PayCircle;
})();
export const Phone = /*#__PURE__*/ (() => {
    function PhoneSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M885.6 230.2L779.1 123.8a80.83 80.83 0 00-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 00-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 01553.1 553 395.34 395.34 0 01437 633.8L353.2 550a80.83 80.83 0 00-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 00-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z" })
        );
    }
    function Phone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PhoneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Phone.SVG = PhoneSVG;
    return Phone;
})();
export const Picture = /*#__PURE__*/ (() => {
    function PictureSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 01-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z" })
        );
    }
    function Picture({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PictureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Picture.SVG = PictureSVG;
    return Picture;
})();
export const PieChart = /*#__PURE__*/ (() => {
    function PieChartSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 00-282.5 117 397.47 397.47 0 00-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 00155.6 31.5 398.57 398.57 0 00282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0031.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 00588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z" })
        );
    }
    function PieChart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PieChartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PieChart.SVG = PieChartSVG;
    return PieChart;
})();
export const PlayCircle = /*#__PURE__*/ (() => {
    function PlayCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 01-12.7-6.5V353.7a8 8 0 0112.7-6.5L656.1 506a7.9 7.9 0 010 12.9z" })
        );
    }
    function PlayCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlayCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PlayCircle.SVG = PlayCircleSVG;
    return PlayCircle;
})();
export const PlaySquare = /*#__PURE__*/ (() => {
    function PlaySquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 010 17.6z" })
        );
    }
    function PlaySquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlaySquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PlaySquare.SVG = PlaySquareSVG;
    return PlaySquare;
})();
export const PlusCircle = /*#__PURE__*/ (() => {
    function PlusCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" })
        );
    }
    function PlusCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlusCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PlusCircle.SVG = PlusCircleSVG;
    return PlusCircle;
})();
export const PlusSquare = /*#__PURE__*/ (() => {
    function PlusSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" })
        );
    }
    function PlusSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlusSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PlusSquare.SVG = PlusSquareSVG;
    return PlusSquare;
})();
export const PoundCircle = /*#__PURE__*/ (() => {
    function PoundCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 01-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z" })
        );
    }
    function PoundCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PoundCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PoundCircle.SVG = PoundCircleSVG;
    return PoundCircle;
})();
export const Printer = /*#__PURE__*/ (() => {
    function PrinterSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z" })
        );
    }
    function Printer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PrinterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Printer.SVG = PrinterSVG;
    return Printer;
})();
export const Profile = /*#__PURE__*/ (() => {
    function ProfileSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z" })
        );
    }
    function Profile({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ProfileSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Profile.SVG = ProfileSVG;
    return Profile;
})();
export const Project = /*#__PURE__*/ (() => {
    function ProjectSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z" })
        );
    }
    function Project({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ProjectSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Project.SVG = ProjectSVG;
    return Project;
})();
export const PropertySafety = /*#__PURE__*/ (() => {
    function PropertySafetySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 018.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z" })
        );
    }
    function PropertySafety({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PropertySafetySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PropertySafety.SVG = PropertySafetySVG;
    return PropertySafety;
})();
export const Pushpin = /*#__PURE__*/ (() => {
    function PushpinSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z" })
        );
    }
    function Pushpin({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PushpinSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pushpin.SVG = PushpinSVG;
    return Pushpin;
})();
export const QqCircle = /*#__PURE__*/ (() => {
    function QqCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z" })
        );
    }
    function QqCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( QqCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    QqCircle.SVG = QqCircleSVG;
    return QqCircle;
})();
export const QqSquare = /*#__PURE__*/ (() => {
    function QqSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z" })
        );
    }
    function QqSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( QqSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    QqSquare.SVG = QqSquareSVG;
    return QqSquare;
})();
export const QuestionCircle = /*#__PURE__*/ (() => {
    function QuestionCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 00-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z" })
        );
    }
    function QuestionCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( QuestionCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    QuestionCircle.SVG = QuestionCircleSVG;
    return QuestionCircle;
})();
export const Read = /*#__PURE__*/ (() => {
    function ReadSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 00324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z" })
        );
    }
    function Read({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ReadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Read.SVG = ReadSVG;
    return Read;
})();
export const Reconciliation = /*#__PURE__*/ (() => {
    function ReconciliationSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z" })
        );
    }
    function Reconciliation({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ReconciliationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Reconciliation.SVG = ReconciliationSVG;
    return Reconciliation;
})();
export const RedEnvelope = /*#__PURE__*/ (() => {
    function RedEnvelopeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 017.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z" })
        );
    }
    function RedEnvelope({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RedEnvelopeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RedEnvelope.SVG = RedEnvelopeSVG;
    return RedEnvelope;
})();
export const RedditCircle = /*#__PURE__*/ (() => {
    function RedditCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M584 548a36 36 0 1072 0 36 36 0 10-72 0zm144-108a35.9 35.9 0 00-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 00728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 01296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 01101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 00-30.1-3.6zM296 440a35.98 35.98 0 00-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 00296 440zm72 108a36 36 0 1072 0 36 36 0 10-72 0z" })
        );
    }
    function RedditCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RedditCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RedditCircle.SVG = RedditCircleSVG;
    return RedditCircle;
})();
export const RedditSquare = /*#__PURE__*/ (() => {
    function RedditSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M296 440a35.98 35.98 0 00-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 00296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 00-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 01296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 01101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1072 0 36 36 0 10-72 0zm144-108a35.9 35.9 0 00-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 00728 440zM368 548a36 36 0 1072 0 36 36 0 10-72 0z" })
        );
    }
    function RedditSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RedditSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RedditSquare.SVG = RedditSquareSVG;
    return RedditSquare;
})();
export const Rest = /*#__PURE__*/ (() => {
    function RestSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 10160 0 80 80 0 10-160 0z" })
        );
    }
    function Rest({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RestSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rest.SVG = RestSVG;
    return Rest;
})();
export const RightCircle = /*#__PURE__*/ (() => {
    function RightCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z" })
        );
    }
    function RightCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RightCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RightCircle.SVG = RightCircleSVG;
    return RightCircle;
})();
export const RightSquare = /*#__PURE__*/ (() => {
    function RightSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z" })
        );
    }
    function RightSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RightSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RightSquare.SVG = RightSquareSVG;
    return RightSquare;
})();
export const Robot = /*#__PURE__*/ (() => {
    function RobotSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM300 328c0-33.1 26.9-60 60-60s60 26.9 60 60-26.9 60-60 60-60-26.9-60-60zm372 248c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-60c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v60zm-8-188c-33.1 0-60-26.9-60-60s26.9-60 60-60 60 26.9 60 60-26.9 60-60 60zm135 476H225c-13.8 0-25 14.3-25 32v56c0 4.4 2.8 8 6.2 8h611.5c3.4 0 6.2-3.6 6.2-8v-56c.1-17.7-11.1-32-24.9-32z" })
        );
    }
    function Robot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RobotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Robot.SVG = RobotSVG;
    return Robot;
})();
export const Rocket = /*#__PURE__*/ (() => {
    function RocketSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 010 96 48.01 48.01 0 010-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z" })
        );
    }
    function Rocket({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RocketSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rocket.SVG = RocketSVG;
    return Rocket;
})();
export const SafetyCertificate = /*#__PURE__*/ (() => {
    function SafetyCertificateSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z" })
        );
    }
    function SafetyCertificate({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SafetyCertificateSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SafetyCertificate.SVG = SafetyCertificateSVG;
    return SafetyCertificate;
})();
export const Save = /*#__PURE__*/ (() => {
    function SaveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" })
        );
    }
    function Save({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SaveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Save.SVG = SaveSVG;
    return Save;
})();
export const Schedule = /*#__PURE__*/ (() => {
    function ScheduleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 01-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z" })
        );
    }
    function Schedule({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ScheduleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Schedule.SVG = ScheduleSVG;
    return Schedule;
})();
export const SecurityScan = /*#__PURE__*/ (() => {
    function SecurityScanSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 01-11.3 0l-34-34a8.03 8.03 0 010-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 10113.27-113.28 80.1 80.1 0 10-113.27 113.28z" })
        );
    }
    function SecurityScan({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SecurityScanSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SecurityScan.SVG = SecurityScanSVG;
    return SecurityScan;
})();
export const Setting = /*#__PURE__*/ (() => {
    function SettingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 00-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 009.3-35.2l-.9-2.6a442.5 442.5 0 00-79.6-137.7l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.3a353.44 353.44 0 00-98.9 57.3l-81.8-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a445.93 445.93 0 00-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0025.8 25.7l2.7.5a448.27 448.27 0 00158.8 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z" })
        );
    }
    function Setting({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SettingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Setting.SVG = SettingSVG;
    return Setting;
})();
export const Shop = /*#__PURE__*/ (() => {
    function ShopSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z" })
        );
    }
    function Shop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shop.SVG = ShopSVG;
    return Shop;
})();
export const Shopping = /*#__PURE__*/ (() => {
    function ShoppingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z" })
        );
    }
    function Shopping({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShoppingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shopping.SVG = ShoppingSVG;
    return Shopping;
})();
export const Signal = /*#__PURE__*/ (() => {
    function SignalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M584 352H440c-17.7 0-32 14.3-32 32v544c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32zM892 64H748c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM276 640H132c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V672c0-17.7-14.3-32-32-32z" })
        );
    }
    function Signal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SignalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Signal.SVG = SignalSVG;
    return Signal;
})();
export const SketchCircle = /*#__PURE__*/ (() => {
    function SketchCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 01-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 010 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z" })
        );
    }
    function SketchCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SketchCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SketchCircle.SVG = SketchCircleSVG;
    return SketchCircle;
})();
export const SketchSquare = /*#__PURE__*/ (() => {
    function SketchSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 01-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 010 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z" })
        );
    }
    function SketchSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SketchSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SketchSquare.SVG = SketchSquareSVG;
    return SketchSquare;
})();
export const Skin = /*#__PURE__*/ (() => {
    function SkinSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44z" })
        );
    }
    function Skin({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SkinSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Skin.SVG = SkinSVG;
    return Skin;
})();
export const Skype = /*#__PURE__*/ (() => {
    function SkypeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 00-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 00335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 00112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z" })
        );
    }
    function Skype({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SkypeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Skype.SVG = SkypeSVG;
    return Skype;
})();
export const SlackCircle = /*#__PURE__*/ (() => {
    function SlackCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" })
        );
    }
    function SlackCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SlackCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SlackCircle.SVG = SlackCircleSVG;
    return SlackCircle;
})();
export const SlackSquare = /*#__PURE__*/ (() => {
    function SlackSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" })
        );
    }
    function SlackSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SlackSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SlackSquare.SVG = SlackSquareSVG;
    return SlackSquare;
})();
export const Sliders = /*#__PURE__*/ (() => {
    function SlidersSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z" })
        );
    }
    function Sliders({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SlidersSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sliders.SVG = SlidersSVG;
    return Sliders;
})();
export const Smile = /*#__PURE__*/ (() => {
    function SmileSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 018-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 018 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" })
        );
    }
    function Smile({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SmileSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Smile.SVG = SmileSVG;
    return Smile;
})();
export const Snippets = /*#__PURE__*/ (() => {
    function SnippetsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z" })
        );
    }
    function Snippets({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SnippetsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Snippets.SVG = SnippetsSVG;
    return Snippets;
})();
export const Sound = /*#__PURE__*/ (() => {
    function SoundSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M892.1 737.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z" })
        );
    }
    function Sound({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SoundSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sound.SVG = SoundSVG;
    return Sound;
})();
export const Star = /*#__PURE__*/ (() => {
    function StarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" })
        );
    }
    function Star({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Star.SVG = StarSVG;
    return Star;
})();
export const StepBackward = /*#__PURE__*/ (() => {
    function StepBackwardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 1024 : '1em',
                height: originalSize ? 1024 : '1em',
                viewBox: "0 0 1024 1024",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 000 33.9M330 864h-64a8 8 0 01-8-8V168a8 8 0 018-8h64a8 8 0 018 8v688a8 8 0 01-8 8" })
        );
    }
    function StepBackward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StepBackwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StepBackward.SVG = StepBackwardSVG;
    return StepBackward;
})();
export const StepForward = /*#__PURE__*/ (() => {
    function StepForwardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 1024 : '1em',
                height: originalSize ? 1024 : '1em',
                viewBox: "0 0 1024 1024",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 010 33.9M694 864h64a8 8 0 008-8V168a8 8 0 00-8-8h-64a8 8 0 00-8 8v688a8 8 0 008 8" })
        );
    }
    function StepForward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StepForwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StepForward.SVG = StepForwardSVG;
    return StepForward;
})();
export const Stop = /*#__PURE__*/ (() => {
    function StopSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z" })
        );
    }
    function Stop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stop.SVG = StopSVG;
    return Stop;
})();
export const Switcher = /*#__PURE__*/ (() => {
    function SwitcherSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z" })
        );
    }
    function Switcher({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SwitcherSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Switcher.SVG = SwitcherSVG;
    return Switcher;
})();
export const Tablet = /*#__PURE__*/ (() => {
    function TabletSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" })
        );
    }
    function Tablet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TabletSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tablet.SVG = TabletSVG;
    return Tablet;
})();
export const Tag = /*#__PURE__*/ (() => {
    function TagSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z" })
        );
    }
    function Tag({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TagSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tag.SVG = TagSVG;
    return Tag;
})();
export const Tags = /*#__PURE__*/ (() => {
    function TagsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z" })
        );
    }
    function Tags({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TagsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tags.SVG = TagsSVG;
    return Tags;
})();
export const TaobaoCircle = /*#__PURE__*/ (() => {
    function TaobaoCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" })
        );
    }
    function TaobaoCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TaobaoCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TaobaoCircle.SVG = TaobaoCircleSVG;
    return TaobaoCircle;
})();
export const TaobaoSquare = /*#__PURE__*/ (() => {
    function TaobaoSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" })
        );
    }
    function TaobaoSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TaobaoSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TaobaoSquare.SVG = TaobaoSquareSVG;
    return TaobaoSquare;
})();
export const Thunderbolt = /*#__PURE__*/ (() => {
    function ThunderboltSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z" })
        );
    }
    function Thunderbolt({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ThunderboltSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Thunderbolt.SVG = ThunderboltSVG;
    return Thunderbolt;
})();
export const Tool = /*#__PURE__*/ (() => {
    function ToolSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 00419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z" })
        );
    }
    function Tool({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ToolSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tool.SVG = ToolSVG;
    return Tool;
})();
export const TrademarkCircle = /*#__PURE__*/ (() => {
    function TrademarkCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z" })
        );
    }
    function TrademarkCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TrademarkCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TrademarkCircle.SVG = TrademarkCircleSVG;
    return TrademarkCircle;
})();
export const Trophy = /*#__PURE__*/ (() => {
    function TrophySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z" })
        );
    }
    function Trophy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TrophySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Trophy.SVG = TrophySVG;
    return Trophy;
})();
export const TwitterCircle = /*#__PURE__*/ (() => {
    function TwitterCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 01-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 01-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 00229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z" })
        );
    }
    function TwitterCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TwitterCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TwitterCircle.SVG = TwitterCircleSVG;
    return TwitterCircle;
})();
export const TwitterSquare = /*#__PURE__*/ (() => {
    function TwitterSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 01-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 01-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 00229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z" })
        );
    }
    function TwitterSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TwitterSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TwitterSquare.SVG = TwitterSquareSVG;
    return TwitterSquare;
})();
export const Unlock = /*#__PURE__*/ (() => {
    function UnlockSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1156 0z" })
        );
    }
    function Unlock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UnlockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Unlock.SVG = UnlockSVG;
    return Unlock;
})();
export const UpCircle = /*#__PURE__*/ (() => {
    function UpCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z" })
        );
    }
    function UpCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UpCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    UpCircle.SVG = UpCircleSVG;
    return UpCircle;
})();
export const UpSquare = /*#__PURE__*/ (() => {
    function UpSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z" })
        );
    }
    function UpSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UpSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    UpSquare.SVG = UpSquareSVG;
    return UpSquare;
})();
export const Usb = /*#__PURE__*/ (() => {
    function UsbSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" })
        );
    }
    function Usb({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UsbSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Usb.SVG = UsbSVG;
    return Usb;
})();
export const VideoCamera = /*#__PURE__*/ (() => {
    function VideoCameraSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z" })
        );
    }
    function VideoCamera({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VideoCameraSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    VideoCamera.SVG = VideoCameraSVG;
    return VideoCamera;
})();
export const Wallet = /*#__PURE__*/ (() => {
    function WalletSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1080 0 40 40 0 10-80 0z" })
        );
    }
    function Wallet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WalletSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wallet.SVG = WalletSVG;
    return Wallet;
})();
export const Warning = /*#__PURE__*/ (() => {
    function WarningSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" })
        );
    }
    function Warning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Warning.SVG = WarningSVG;
    return Warning;
})();
export const Wechat = /*#__PURE__*/ (() => {
    function WechatSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 006.4-2.6 9 9 0 002.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 01-36 35.9z" })
        );
    }
    function Wechat({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WechatSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wechat.SVG = WechatSVG;
    return Wechat;
})();
export const WeiboCircle = /*#__PURE__*/ (() => {
    function WeiboCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" })
        );
    }
    function WeiboCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WeiboCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    WeiboCircle.SVG = WeiboCircleSVG;
    return WeiboCircle;
})();
export const WeiboSquare = /*#__PURE__*/ (() => {
    function WeiboSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" })
        );
    }
    function WeiboSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WeiboSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    WeiboSquare.SVG = WeiboSquareSVG;
    return WeiboSquare;
})();
export const Windows = /*#__PURE__*/ (() => {
    function WindowsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z" })
        );
    }
    function Windows({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WindowsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Windows.SVG = WindowsSVG;
    return Windows;
})();
export const Yahoo = /*#__PURE__*/ (() => {
    function YahooSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z" })
        );
    }
    function Yahoo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( YahooSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Yahoo.SVG = YahooSVG;
    return Yahoo;
})();
export const Youtube = /*#__PURE__*/ (() => {
    function YoutubeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M941.3 296.1a112.3 112.3 0 00-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0082.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z" })
        );
    }
    function Youtube({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( YoutubeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Youtube.SVG = YoutubeSVG;
    return Youtube;
})();
export const Yuque = /*#__PURE__*/ (() => {
    function YuqueSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z" })
        );
    }
    function Yuque({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( YuqueSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Yuque.SVG = YuqueSVG;
    return Yuque;
})();
export const ZhihuCircle = /*#__PURE__*/ (() => {
    function ZhihuCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z" })
        );
    }
    function ZhihuCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ZhihuCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ZhihuCircle.SVG = ZhihuCircleSVG;
    return ZhihuCircle;
})();
export const ZhihuSquare = /*#__PURE__*/ (() => {
    function ZhihuSquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 832 : '1em',
                height: originalSize ? 832 : '1em',
                viewBox: "64 64 896 896",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z" })
        );
    }
    function ZhihuSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ZhihuSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ZhihuSquare.SVG = ZhihuSquareSVG;
    return ZhihuSquare;
})();
